import { render } from "./payment-information.vue?vue&type=template&id=52547156"
import script from "./payment-information.vue?vue&type=script&lang=js"
export * from "./payment-information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__